import { rest } from 'msw'

import { User } from 'models/User'

import { coreApiBase } from './coreApiBase'
import { isTest } from '../../isTest'
import { IBeneficiaryPublic } from '@cms-max/medicare-api-sdk'

const beneficiaryBaseEndpoint = `${coreApiBase}/beneficiary`

export const mockBeneficiaryRes = (userResponse: User) => {
  return rest.get(`${beneficiaryBaseEndpoint}`, (_, res, ctx) => {
    return res(
      ctx.delay(isTest ? 0 : undefined),
      ctx.json(userResponse)
    )
  })
}

export const mockBeneficiaryReqTokenRes = (userResponse: IBeneficiaryPublic) => {
  return rest.get(`${beneficiaryBaseEndpoint}/:reqToken`, (_, res, ctx) => {
    return res(
      ctx.delay(isTest ? 0 : undefined),
      ctx.json(userResponse)
    )
  })
}
